export default [
  {
    for: 'a11y-scanner',
    actions: {
      create: true,
      update: true,
      read: true,
      delete: true,
    },
  },
  {
    for: 'a11y-scan',
    actions: {
      create: true,
      update: true,
      read: true,
      delete: true,
    },
  },
  {
    for: 'a11y-report',
    actions: {
      read: true,
    },
  },
  {
    for: 'a11y-quickscan',
    actions: {
      read: true,
      create: true,
    },
  },
];
